module.exports = __webpack_public_path__ + "static/img/with.6009827a.png";